import { withStyles } from '@material-ui/core/styles';

import EditForm from '../maintainer/edit';
import form from './change-password-form';
import UserService from '../../services/user-service';
import { isRequired, isValidUser } from '../../libraries/validators';
import { reduceSpaces } from '../../libraries/utils';
import { PASSWORD_IS_NOT_THE_SAME_USER } from '../../libraries/texts';

import { editionMaintainer as styles } from '../maintainer/styles';

const EditPassword = props => {
  const service = UserService;
  const {
    match: {
      params: { id }
    }
  } = props;

  const getErrors = values => {
    const errors = {};
    const minimumValues = {
      oldPassword: values.oldPassword,
      password: values.password,
      confirmPassword: values.confirmPassword
    };

    const newValues = Object.entries(minimumValues).reduce(reduceSpaces, {});
    isRequired(errors, newValues);

    isValidUser(errors, newValues);
    return errors;
  };

  const wrapperInformation = newValues => {
    const finalValues = {
      oldPassword: newValues.oldPassword,
      password: newValues.password,
      confirmPassword: newValues.confirmPassword
    };

    return finalValues;
  };
  const errorWrapper = props => err => {
    const { setFieldError } = props;
    const val = 'oldPassword';
    const valErrors = err.filter(
      elem => elem.includes('oldPassword') && elem.includes('Not Authorized')
    );
    if (valErrors.length > 0) {
      setFieldError(val, PASSWORD_IS_NOT_THE_SAME_USER);
    }
  };

  const initialWrapperData = values => {
    const newValues = { ...values };
    if (id) {
      newValues.password = '';
      newValues.confirmPassword = '';
    }
    return newValues;
  };
  const redirectListPage = () => '/';
  return {
    props,
    errorWrapper,
    getErrors,
    wrapperInformation,
    initialWrapperData,
    service: { ...service, put: service.changePassword, redirectListPage },
    keyName: 'code'
  };
};

export default withStyles(styles)(EditForm(EditPassword)(form));
